var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"empty",style:({ 'margin-top': _vm.marginTop })},[_c('div',{staticClass:"empty-icon-content"},[_c('svg-icon',{attrs:{"icon-class":"empty","size":_vm.size}})],1),_c('div',{staticClass:"tips"},[_vm._v(_vm._s(_vm.message))])])
}
var staticRenderFns = []

export { render, staticRenderFns }